import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import MedecinLayout from './layouts/medecin';
import {
  ChakraProvider,
  // extendTheme
} from '@chakra-ui/react';
import initialTheme from './theme/theme'; //  { themeGreen }
import { useState } from 'react';
import GoogleMapsLoader from "components/GoogleMapsLoader";
import PrestationMap from "views/prestation"; // Ajout de l'import correct
import { CallsProvider } from './contexts/CallsContext';
import { PermissionsProvider } from './contexts/PermissionsContext';
// Chakra imports

export default function Main() {
  // eslint-disable-next-line
  const [currentTheme, setCurrentTheme] = useState(initialTheme);
  return (
    <GoogleMapsLoader>
      <ChakraProvider theme={currentTheme}>
        <PermissionsProvider>
          <CallsProvider>
            <Routes>
              <Route path="auth/*" element={<AuthLayout />} />
              <Route path="prestation/:id" element={<PrestationMap />} />
              <Route
                path="admin/*"
                element={
                  <AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />
                }
              />
              <Route
                path="medecin/*"
                element={
                  <MedecinLayout theme={currentTheme} setTheme={setCurrentTheme} />
                }
              />
              <Route path="/" element={<Navigate to="/admin" replace />} />
            </Routes>
          </CallsProvider>
        </PermissionsProvider>
      </ChakraProvider>
    </GoogleMapsLoader>
  );
}

